import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/layout';
import Static from '../components/static';
import Avatar from '../components/avatar';
import A from '../components/a';
import Heading from '../components/heading';

const AuthorName = ({ children }) => <h4 css={{ marginTop: 24 }}>{children}</h4>;

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <Static>
            <Helmet title="About Us" meta={[{ property: 'og:title', content: 'About Us' }]} />
            <Heading>About Us</Heading>
            <h3>Our Vision:</h3>
            <p>Everyday we make financial decisions, big and small, that impact our overall wealth.  We believe that teaching the basic, advanced, and Wyse elements of these decisions will help everyone increase their wealth dramatically in the aggregate.</p>

            <h3>Who We Are:</h3>

            <p>We are a group of business professionals, lawyers, and engineers that are passionate about making good financial decisions. We know that if we can improve our understanding of the impacts of our financial decisions we can live better lives.  We believe in helping others understand how financial and life decisions in their lives can lead to increased financial freedom.</p>

            <AuthorName>Stephen N.</AuthorName>
            <Avatar author="Stephen N." />
            <p css={{ marginTop: 16 }}>Military computer scientist turned lawyer. I’m a car guy; I’ve always loved fast cars and bad decisions, but recently purchased a Honda CRV after using our calculators to understand the true financial impact of that roadster.  Here I am, a car guy, driving a CRV, passionate about the decision I made to live a healthier financial life.</p>

            <AuthorName>Cristian D.</AuthorName>
            <Avatar author="Cristian D." />
            <p css={{ marginTop: 16 }}>Was financially irresponsible and amassed quite a bit of debt while studying physics and music in college. Since then, after bouncing between a few different career paths, settled on software engineering. Now debt free and focussed on saving for the future.</p>

            <AuthorName>Aaron A.</AuthorName>
            <Avatar author="Aaron A." />
            <p css={{ marginTop: 16 }}>Graduated from law school during a recession, six figures in debt. Struggling at an early age made me careful, and once I got out of the red I was determined to stay in the green. Look out for those golden handcuffs. When I bought a house, I made my own calculator because I wasn’t getting the info I needed anywhere else. Financially neurotic? Let‘s just go with informed.</p>

            <p css={{ marginTop: 16 }}>Questions or feedback? Feel free to reach out at <A href="mailto:info@walletwyse.com" target="_blank" isExternal>info@walletwyse.com</A>.</p>
        </Static>
    </Layout>
);
